import { httpCreate } from './http';

const http = httpCreate('/shop/api/activity-blind-box-order');

export const activityBlindBoxOrder = {
	/** 获取列表
	 * @param { Number } boxActivityId  直播间id
	 * @param { Number } params.pageNum 当前页数
	 * @param { Number } params.pageSize    每页显示的数目(默认5)
	 * @param { String } params.boxGroupName    盲盒活动id
	 * @param { String } params.proName     盲盒组名称
	 * @param { String } params.nameOrPhone 收件人
	 * @returns
	 */
	getOrderList(boxActivityId, params) {
		return http.get(`/list/${boxActivityId}`, { params });
	},
	// 删除详情
	deleteOrder(orderId) {
		return http.delete(`/${orderId}`);
	},
};
